import { gql } from "@apollo/client";

export const AssetLocationClientContract = gql`
    query AssetLocationClientContract ($id: ID!) {
        assetLocation (id: $id) {
            id
            warrantyEndDate
            installedBaseNode {
                id
                pathNodes {
                    id
                    title
                    nodeType {
                        key
                    }
                }
            }
            owner {
                id
                industryType
                contract {
                    id
                    contractDurationFrom
                    contractDurationTo
                }
            }
        }
    }
`;
